<script setup>
import BrandMark from './BrandMark.vue'
</script>

<template>
  <footer class="landing-footer">
    <RouterLink class="brand" to="/"><BrandMark /><span>Промптгесс</span></RouterLink>
    <p>Игра для тех, кто любит картинки,<br />слова и неожиданные совпадения.</p>
    <nav aria-label="Ссылки внизу страницы">
      <RouterLink to="/how-to">Как играть</RouterLink>
      <RouterLink to="/friends">Для компании</RouterLink>
      <RouterLink to="/kids">Для детей</RouterLink>
      <RouterLink to="/solo">Игра с ИИ</RouterLink>
      <RouterLink to="/buy">Игры и подписка</RouterLink>
      <RouterLink to="/games">Мои игры</RouterLink>
      <RouterLink to="/generate">Рисовать</RouterLink>
    </nav>
  </footer>
</template>
